export default "/images/vendor/@alquiler-argentina/aa-componentes/es/marker-aa_c_30.png?a6db5aad9b286472b2b2c954edc5d254";